import React, { useState } from "react";
import { FaRegLightbulb, FaPen, FaCode, FaRocket, FaArrowRight, FaApple, FaAndroid } from "react-icons/fa6";
import { SiFlutter } from "react-icons/si";
import { Container } from "../home/ui";
import { Eyebrow, H2, edgeFade } from "./mobileUi";

// Left artwork (phone with app + iOS/Android/Flutter tiles). Put the file at public/img/mobile-process.jpg
// (or change the path). Until it exists, a simple placeholder with the platform tiles is shown.
const processImg = "/img/mobile-process.jpg";

const steps = [
  { icon: FaRegLightbulb, title: "Discovery & Planning", text: "Understand your goals, users and business needs." },
  { icon: FaPen, title: "Design & Prototyping", text: "Create intuitive UI/UX and interactive prototypes." },
  { icon: FaCode, title: "Development & Testing", text: "Build, test and optimize for performance." },
  { icon: FaRocket, title: "Launch & Support", text: "Deploy to app stores and provide ongoing support." },
];

const Placeholder = () => (
  <div className="relative mx-auto aspect-[4/3.4] w-full max-w-[460px]">
    <div className="absolute inset-[8%_18%_0_0] rounded-[45%_55%_50%_50%/55%_45%_55%_45%] bg-[#E3E8FF]" />
    <div className="absolute bottom-0 left-[14%] top-[4%] w-[46%] rounded-[34px] border-[6px] border-solid border-[#1F2937] bg-gradient-to-b from-[#3D5AFE] via-white to-white" />
    {[FaApple, FaAndroid, SiFlutter].map((Icon, i) => (
      <span
        key={i}
        className={`absolute right-[8%] inline-flex h-[60px] w-[60px] items-center justify-center rounded-[16px] bg-white text-[30px] shadow-[0_10px_24px_-12px_rgba(15,27,76,0.35)] ${
          ["top-[8%] text-[#111827]", "top-[38%] text-[#3DDC84]", "top-[68%] text-[#42A5F5]"][i]
        }`}
      >
        <Icon />
      </span>
    ))}
  </div>
);

const MobileProcess = () => {
  const [failed, setFailed] = useState(false);

  return (
    <section className="bg-white py-[48px] lg:py-[64px]">
      <Container className="max-w-[1320px]">
        <div className="grid items-center gap-[40px] lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-[48px]">
          <div>
            {failed ? (
              <Placeholder />
            ) : (
              <img
                src={processImg}
                onError={() => setFailed(true)}
                alt="Mobile app on a phone with iOS, Android and Flutter icons"
                className="mx-auto h-auto w-full max-w-[480px] select-none object-contain"
                style={edgeFade}
              />
            )}
          </div>

          <div>
            <Eyebrow>Our Development Process</Eyebrow>
            <H2 className="mt-[14px]">From Idea to App Store</H2>
            <p className="mt-[12px] max-w-[560px] text-[15px] leading-[1.65] text-slate-600 sm:text-[16px]">
              We follow a collaborative and agile approach to ensure your app is delivered on time, within budget and beyond
              expectations.
            </p>

            <div className="mt-[32px] grid gap-[28px] sm:grid-cols-2 lg:grid-cols-4 lg:gap-[16px]">
              {steps.map((s, i) => (
                <div key={s.title} className="relative">
                  {i < steps.length - 1 && (
                    <FaArrowRight className="absolute right-[14%] top-[16px] hidden text-[15px] text-[#9AA8D6] lg:block" aria-hidden="true" />
                  )}
                  <span className="inline-flex h-[48px] w-[48px] items-center justify-center rounded-full bg-[#EEF0FF] text-[20px] text-[#4F46E5]">
                    <s.icon />
                  </span>
                  <p className="mt-[18px] text-[18px] font-medium text-[#8A93B5]">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="mt-[6px] text-[15px] font-semibold text-[#0F1B4C]">{s.title}</h3>
                  <p className="mt-[8px] max-w-[200px] text-[13.5px] leading-[1.6] text-slate-500">{s.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default MobileProcess;
